import { PropertyHelper } from "@/helpers/property.helper";
import { IntegerValidator } from "@/validators/IntegerValidator";
import { NgIf } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  FormControl,
  ReactiveFormsModule,
  UntypedFormBuilder,
  Validators,
} from "@angular/forms";
import { MatRadioModule } from "@angular/material/radio";
import { PropertySale, PropertyType } from "@eemo/api-client";
import { Subscription } from "rxjs";
import { RealPropertyMutable } from "../property-add-full-dialog/property-add-full-dialog.component";
import { InputComponent } from "../ui-forms/input/input.component";

@Component({
  selector: "app-property-add-sale",
  templateUrl: "./property-add-sale.component.html",
  styleUrls: ["./property-add-sale.component.scss"],
  standalone: true,
  imports: [ReactiveFormsModule, MatRadioModule, InputComponent, NgIf],
})
export class PropertyAddSaleComponent implements OnInit, OnDestroy {
  @Input() prop: RealPropertyMutable;
  @Input() propSale: PropertySale;
  @Output() propertySaleUpdated = new EventEmitter<PropertySale>();
  @Output() propertyUpdated = new EventEmitter<RealPropertyMutable>();

  formSubmitting = false;
  sub = new Subscription();
  showCoproOption = true;

  get form_isInCondo() {
    return this.form.get("isInCondo") as FormControl<boolean>;
  }
  get form_isToSale() {
    return this.form.get("isToSale") as FormControl<boolean>;
  }
  get form_price() {
    return this.form.get("price") as FormControl<number>;
  }
  get form_dateOnSale() {
    return this.form.get("dateOnSale") as FormControl<string>;
  }
  get form_promotionalText() {
    return this.form.get("promotionalText") as FormControl<string>;
  }

  form = this.fb.group({
    isInCondo: [false, Validators.required],
    isToSale: [true, Validators.required],
    price: [null, [IntegerValidator, Validators.required]],
    dateOnSale: [null, Validators.required],
    promotionalText: [null],
  });

  constructor(
    private fb: UntypedFormBuilder,
    private propHelper: PropertyHelper
  ) {}

  ngOnInit(): void {
    this.showCoproOption = this.prop.type !== PropertyType.CONDOMINIUM;
    this.sub = this.form_isToSale.valueChanges.subscribe((v) => {
      if (v) {
        this.form_price.enable();
        this.form_dateOnSale.enable();
        this.form_promotionalText.enable();
      } else {
        this.form_price.disable();
        this.form_dateOnSale.disable();
        this.form_promotionalText.disable();
      }
    });
    if (this.prop.onGoingSelling && !this.propSale) {
      this.propSale = {
        dateOnSale: this.prop.onGoingSelling.dateOnSale,
        price: this.prop.onGoingSelling.price,
      };
    }
    if (this.propSale) {
      this.form_isToSale.setValue(true);
      this.form_price.setValue(this.propSale.price);
      this.form_dateOnSale.setValue(this.propSale.dateOnSale);
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  onSubmit() {
    if (this.form.valid) {
      this.formSubmitting = true;
      this.prop.details = { isInCondo: this.form_isInCondo.value };
      this.propertyUpdated.emit(this.prop);
      if (this.form_isToSale.value) {
        this.propSale = {
          price: this.form_price.value,
          dateOnSale: this.form_dateOnSale.value,
          promotionalText: this.form_promotionalText.value,
        };
      } else {
        this.propSale = null;
      }
      this.formSubmitting = false;
    }
    this.propertySaleUpdated.emit(this.propSale);
  }
}
